import React from "react";
import "../../../css/Praplanning/ParaplanningSelectedFilterChips.css";

import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";

const ParaplanningSelectedFilterChips = ({
  selectedAdvisers = [],
  selectedCaseTypes = [],
  selectedStatuses = [],
  selectedCatalogs = [],
  selectedAssignedTo = [],
  onRemoveAdviser,
  onRemoveCaseType,
  onRemoveStatus,
  onRemoveCatalog,
  onRemoveAssignedTo,
  onClearAll,
}) => {
  const hasFilters =
    selectedAdvisers.length ||
    selectedCaseTypes.length ||
    selectedStatuses.length ||
    selectedCatalogs.length ||
    selectedAssignedTo.length;

  if (!hasFilters) return null;

  return (
    <div className="ParaplanningSelectedFilters">
      <div className="ParaplanningSelectedFilters__Chips">
        {selectedCatalogs.map((item) => (
          <button
            key={`catalog_${item.id}`}
            type="button"
            className="ParaplanningSelectedFilters__Chip"
            onClick={() => onRemoveCatalog(item.id)}
          >
            <span>{item.label}</span>
            <CloseIcon />
          </button>
        ))}

        {selectedAdvisers.map((item) => (
          <button
            key={`adviser_${item.id}`}
            type="button"
            className="ParaplanningSelectedFilters__Chip"
            onClick={() => onRemoveAdviser(item.id)}
          >
            <span>{item.label}</span>
            <CloseIcon />
          </button>
        ))}

        {selectedCaseTypes.map((item) => (
          <button
            key={`caseType_${item.id}`}
            type="button"
            className="ParaplanningSelectedFilters__Chip"
            onClick={() => onRemoveCaseType(item.id)}
          >
            <span>{item.label}</span>
            <CloseIcon />
          </button>
        ))}

        {selectedStatuses.map((item) => (
          <button
            key={`status_${item.id}`}
            type="button"
            className="ParaplanningSelectedFilters__Chip"
            onClick={() => onRemoveStatus(item.id)}
          >
            <span>{item.label}</span>
            <CloseIcon />
          </button>
        ))}

        {selectedAssignedTo.map((item) => (
          <button
            key={`assignedTo_${item.id}`}
            type="button"
            className="ParaplanningSelectedFilters__Chip"
            onClick={() => onRemoveAssignedTo(item.id)}
          >
            <span>{item.label}</span>
            <CloseIcon />
          </button>
        ))}
      </div>

      <button
        type="button"
        className="ParaplanningSelectedFilters__Clear"
        onClick={onClearAll}
      >
        Clear all
      </button>
    </div>
  );
};

export default ParaplanningSelectedFilterChips;
